import React from 'react';
import { darken, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import Icon from '../../Icon/Icon';

export const ToggleButtons = ({ options = [], value, onChange, variant = "primary", sx }) => {

  const theme = useTheme();

  const getLabelColor = (state = "default") => {
    if (state === "default") {
      if (variant === "primary") return theme.palette.oxfordBlue.main;
      if (variant === "secondary") return theme.palette.oxfordBlue.main;
    } else if (state === "selected") {
      if (variant === "primary") return theme.palette.white.main;
      if (variant === "secondary") return theme.palette.white.main;
    } else if (state === "hover") {
      if (variant === "primary") return darken(theme.palette.primary.main, .1);
      if (variant === "secondary") return darken(theme.palette.secondary.main, .1);
    }
  }

 const getBackground = (state = "default") => {
  if (state === "default") {
    if (variant === "primary") return theme.palette.white.main;
    if (variant === "secondary") return theme.palette.white.main;
  } else if (state === "selected") {
    if (variant === "primary") return theme.palette.primary.main;
    if (variant === "secondary") return theme.palette.secondary.main;
  } else if (state === "hover") {
    if (variant === "primary") return darken(theme.palette.primary.main, .1);
    if (variant === "secondary") return darken(theme.palette.secondary.main, .1);
  }
 }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) onChange(newValue);
      }}
      sx={{
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: 1,
        backgroundColor: '#E0F7FA',
        ...sx
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{
            textTransform: 'none',
            px: 1.5,
            py: 0.5,
            border: 0,
            borderRadius: 0,
            backgroundColor: getBackground(),
            color: getLabelColor(),
            "& svg": {
              fill: getLabelColor(),
            },
            '&.Mui-selected': {
              backgroundColor: getBackground("selected"),
              color: getLabelColor("selected"),
              "& svg": {
                fill: getLabelColor("selected"),
              },
              '&:hover': {
                backgroundColor: getBackground("hover"),
              },
            },
          }}
        >
          {
            option.icon && (
              option.iconSelected && value === option.value ? (
                <Icon name={option.iconSelected} size={16} style={{ marginRight: 8 }} />
              ) : (
                <Icon name={option.icon} size={16} style={{ marginRight: 8 }} />
              )
            )
          }
          <Typography variant="body1">{option.label}</Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}